import { forwardRef } from 'react';
import MuiTextField from '@mui/material/TextField';
import { useTextInput } from 'root/src/client/v2/common/components/form/useTextInput';
export const TextField = forwardRef((props, ref) => {
    const { invalid, shrinkLabel, variant = 'outlined' } = props;
    const { inputColor, inputLabelProps } = useTextInput({
        invalid, shrinkLabel,
    });
    return (<MuiTextField {...props} ref={ref} variant={variant} color={inputColor} InputProps={{ style: { color: inputColor } }} InputLabelProps={inputLabelProps}/>);
});
